import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_SI: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitnes',
  components_header_media_1: 'Za moške',
  components_header_media_2: 'Za ženske',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trenirajte pametneje, počutite se bolje.',
  hero_button_text: 'Začnite zdaj',
  components_ressources_subheader_text: 'Vodniki in nasveti',
  components_ressources_span_text: 'Združuje zemeljski poudarek joge, nadzorovano natančnost pilatesa in dinamičen izziv treninga moči za podporo vsestranskemu in zdravemu življenjskemu slogu.',
  components_ressources_card_1_title: 'Nasveti za jogo',
  components_ressources_card_1_text: 'Hiter vodnik za boljše ravnotežje, dihanje in pretok.',
  components_ressources_card_2_title: 'Nasveti za pilates',
  components_ressources_card_2_text: 'Preprosti nasveti za krepitev mišic trupa in izboljšanje nadzora.',
  components_notes_and_google_title_1: 'Zgradite moč',
  components_notes_and_google_title_2: 'Joga miru',
  components_notes_and_google_title_3: 'Pilates jedro',
  media_content_section_multi_1_subheader_text: 'videoposnetki za usposabljanje',
  media_content_section_multi_2_subheader_text: 'Videoposnetki joge',
  media_content_section_multi_3_subheader_text: 'Videoposnetki pilatesa',
  text_media_1: 'Moški',
  text_media_2: 'Ženske',
  page_media_content_menu_biceps: 'Bicepsi',
  page_media_content_menu_triceps: 'Tricepsi',
  page_media_content_menu_back: 'Nazaj',
  page_media_content_menu_chest: 'Prsni koš',
  page_media_content_menu_legs: 'Noge',
  page_media_content_menu_shoulders: 'Ramena',
  page_media_content_menu_abdominals: 'Trebušne mišice',
  components_text1_subheader_text: 'Zdrava prehrana za vaše aktivno življenje',
  components_text1_span_text: 'Zdravi recepti, ki podpirajo vaš trening in izboljšujejo vaše počutje.',
  components_footer_text: 'Okrepite svoje telo, uravnovesite svoj um in se gibajte smiselno – vaš prostor za telovadnico, jogo in pilates.',
};